import { useMutation } from "react-query";
import http from "infra/http";

function useDeletePost() {
  return useMutation(
    (id: string) => {
      return http.delete(`/v1/mural/${id}`);
    },
    { retry: false }
  );
}

export default useDeletePost;
